const ObjectDefaultColors = (state = "#fff", action)=>{
    if(action.type === "OBJECT_DEFAULT_COLOR"){
        state = action.state
    }
    return state;
}

export default ObjectDefaultColors;